import jwtDecode from "jwt-decode";

export type TokenDates = { expirationDate: number; issueDate: number };

/**
 * Read a bearer token's own lifetime out of it. Renewal is driven by OIDC (`user/oidc.ts`), not
 * from here — this is only for deciding what a *rejected* token means; see `hasExpired` in
 * `user/auth-interceptors.ts`. Throws on anything that is not a decodable JWT.
 */
function decodeTokenDates(token: string): TokenDates {
	const decodedToken = jwtDecode<{ iat: number; exp: number }>(token);
	return { expirationDate: decodedToken.exp, issueDate: decodedToken.iat };
}

export { decodeTokenDates };
